import React, { useState, useEffect, useRef } from "react";
import AdminBackNavigation from "../../../components/CommonComponents/AdminBackNavigation";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import JoditEditor from "jodit-react";
import CameraRetroIcon from "@rsuite/icons/legacy/CameraRetro";
import "./Update_Site_met_settings.css";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import Response_Loading_processing from "../../../../src/layout/Others/Response_Loading_processing";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import { IoMdInformationCircle } from "react-icons/io";
import { useMyContext } from "../../../components/Provider/CommonProvider";

function Update_Site_met_settings(props) {
  const { id } = useParams();
  const [site_select_name, setSite_select_name] = useState([]);
  const [editUser, setEditUser] = useState({
    page_name: "",
    page_page_name: "",
    meta_description: "",
    content_description: "",
    meta_keyword: "",
    image_url: "",
    page_title: "",
  });
  const [editname, setEditname] = useState({
    page_title: "",
  });

  const [loading, setLoading] = useState(true);
  const access_token = localStorage.getItem("access_token");

  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };
  const { fetchRequest, globalImageUplaodAPI } = useMyContext();
  const imageApi = globalImageUplaodAPI();

  const fileInputRef1 = useRef(null);

  const [selectedFile1, setSelectedFile1] = useState(null);
  const [fileError1, setFileError1] = useState("");

  const handleFileChange = (event, fileInputRef, setSelectedFile) => {
    const file = event.target.files[0];

    if (!file) return;

    if (!file.type.startsWith("image/")) {
      setFileError1("Only image files are allowed (JPG, PNG, etc.)");
      fileInputRef.current.value = "";
      setSelectedFile(null);
      return;
    }

    if (file.type === "image/gif") {
      setFileError1("GIF format is not allowed.");
      fileInputRef.current.value = "";
      setSelectedFile(null);
      return;
    }
    setFileError1("");
    setSelectedFile(file);
  };

  const handleDelete = (index) => {
    switch (index) {
      case 1:
        setSelectedFile1(null);
        if (fileInputRef1.current) {
          fileInputRef1.current.value = null;
        }
        break;
      default:
        break;
    }
  };

  const handleChangeFirstdetails = (e) => {
    setEditUser({ ...editUser, meta_description: e });
  };

  const handleChangeContentDescription = (e) => {
    setEditUser({ ...editUser, content_description: e });
  };

  const handleInput = (e) => {
    const { name, value } = e.target;

    // Allow only if not empty or not just whitespace
    if (value === "" || value.trim() !== "") {
      setEditUser((prevEditUser) => ({
        ...prevEditUser,
        [name]: value,
      }));
    }
  };


  useEffect(async () => {
    await axios
      .get(`${process.env.REACT_APP_Baseurl}/admin/site_meta/edit/${id}`, {
        headers: headers,
      })
      .then((response) => {
        var result = response?.data?.SiteMetaSetting;
        var page_nameresult = response?.data?.page_name;
        setSite_select_name(page_nameresult);
        setEditUser(result);
        setEditname(result);
        setLoading(false);
      })
      .catch((error) => console.log(error));
    // await axios
    //   .get(`${process.env.REACT_APP_Baseurl}/admin/site_meta/index`, {
    //     headers: headers,
    //   })
    //   .then((response) => {
    //     var result = response?.data?.site_meta_setting.data;
    //     setSite_select_name(result);
    //     setLoading(false);
    //   })
    //   .catch((error) => console.log(error));
  }, []);

  const [processing, setProcessing] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);

  const [validationMessagepage_name, setValidationMessagepage_name] =
    useState("");
  const [isValidationHiddenpage_name, setIsValidationHiddenpage_name] =
    useState(true);

  const [validationMessagepage_title, setValidationMessagepage_title] =
    useState("");
  const [isValidationHiddenpage_title, setIsValidationHiddenpage_title] =
    useState(true);

  const page_nameInputRef = useRef(null);
  const page_titleInputRef = useRef(null);

  const handleUpdate = async (e) => {
    let focusInputRef = null;

    const trimmedPageTitle = editUser?.page_title?.trim();

    if (editUser?.page_name === "") {
      setValidationMessagepage_name("Name cannot be empty.");
      setIsValidationHiddenpage_name(false);
      focusInputRef = page_nameInputRef;
    }
    if (trimmedPageTitle === "") {
      setValidationMessagepage_title("Title cannot be empty.");
      setIsValidationHiddenpage_title(false);
      focusInputRef = page_titleInputRef;
    }

    if (focusInputRef) {
      focusInputRef.current.focus();
      return;
    }

    e.preventDefault();

    const editInputvalue = {
      page_name: editUser?.page_name,
      page_page_title: editUser?.page_title,
      page_page_name: editUser?.page_page_name,
      page_slug: editUser?.page_slug,
      meta_description: editUser?.meta_description,
      content_description: editUser?.content_description,
      meta_keyword: editUser?.meta_keyword,
      page_title: editUser?.page_title,
    };

    let firstApiStatus = false;
    let secondApiStatus = false;
    let resultapi = null;
    let resjson = null;
    setProcessing(true);
    setShowOverlay(true);

    try {
      const res = await fetch(
        `${process.env.REACT_APP_Baseurl}/admin/site_meta/update/${id}`,
        {
          method: "POST",
          headers: headers,
          body: JSON.stringify(editInputvalue),
        }
      );

      resjson = await res.json();

      if (resjson.status === true) {
        firstApiStatus = true;

        resultapi = resjson;

        var site_metaid = resjson?.updated_SiteMeta_Setting?.id;
        toast.success(resjson.message);
        const formData = new FormData();
        const modelName = "SiteMetaSetting";
        formData.append("id", site_metaid);
        formData.append("modelName", modelName);
        formData.append('imageFields[]', 'meta_image')
        formData.append("site_meta_id", site_metaid);
        // if (selectedFile1) {
        //   formData.append("image", selectedFile1);
        // }

        if (selectedFile1) {
          // Case 1: If a new image is selected, send it
          formData.append("meta_image", selectedFile1);
        } else if (editUser?.image_url) {
          // Case 2: If no new image is selected, send existing image in binary format
          const response = await fetch(editUser.image_url);
          const blob = await response.blob();
          formData.append("meta_image", blob, "image_url.jpg"); // Ensure a filename is provided
        }

        await fetchRequest({
          method: 'POST',
          url: imageApi,
          data: formData,
        });
        secondApiStatus = true;
      }
    } catch (error) {
      toast.error(error);
      console.error("Error:", error);
    }

    if (firstApiStatus && secondApiStatus) {
      setValidationMessagepage_name("");
      setValidationMessagepage_title("");
      props.setApiresponsealert(resultapi);
      props.setShowalert(true);
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } else {
      if (resjson.status === false) {
        var resultError = resjson;
        props.setApiresponsealert(resultError);
        props.setShowalert(true);
        setIsValidationHiddenpage_name(false);
        setValidationMessagepage_title(false);
        setProcessing(false);
        setShowOverlay(false);
      }
    }
  };

  return (
    <>
      <AdminBackNavigation path="/site-meta-settings" text="Back" />
      {showOverlay && (<Response_Processing />)}
      <AdminSaveHeader heading={"Edit Site Meta Settings"} saveText={"Update Settings"} saveMethod={handleUpdate} />
      <FormContainer>
        <LeftWrapper>
          <Wrapper>
            <MessageHeading text={editname?.page_title} />
            <MessageLabel text={"Page Name"} />
            <select
              className="form-select custom-input custom-input-border w-100 custom-placeholder bg-transparent theme-text-color mb-3"
              name="page_name"
              id="page_name"
              onChange={handleInput}
              ref={page_nameInputRef}
              value={editUser?.page_name}
              style={{ fontSize: '14px' }}
            >
              <option value="">Select an Page Name </option>

              {site_select_name.map((item, index) => (
                <option key={index} value={Object.keys(item)[0]}>
                  {Object.values(item)[0]}
                </option>
              ))}
            </select>
            <span className="errorred">
              {!isValidationHiddenpage_name && (
                <p>{validationMessagepage_name}</p>
              )}
            </span>
            <MessageLabel text={"Page Title"} className="mandatorySimple" />
            <AdminCustomInput type="text" placeHolder={"Enter page title"} id="page_title" name="page_title" onChange={handleInput} ref={page_titleInputRef} value={editUser?.page_title} error={validationMessagepage_title} />
            <MessageLabel text={"Meta Keyword"} />
            <AdminCustomInput type="text" placeHolder={"Enter meta keyword"} id="meta_keyword" name="meta_keyword" onChange={handleInput} value={editUser?.meta_keyword} />
            <MessageLabel text={"Page Meta Description"} />
            <div className="mt-2">
              <JoditEditor
                className="rs-input"
                value={editUser?.meta_description}
                onChange={(e) => {
                  handleChangeFirstdetails(e);
                }}
              />
            </div>

          </Wrapper>
        </LeftWrapper>
        <RightWrapper>
          <Wrapper>
            <MessageHeading text={"Thumbnails"} />
            <MessageLabel text={"Cover Image"} />
            <div>
              {loading ? (
                <Response_Loading_processing></Response_Loading_processing>
              ) : (
                <img
                  src={editUser?.image_url}
                  // alt="Image"
                  className="thumbnails-images"
                />
              )}
            </div>
            <div className="col-lg-12 row">
              <div className=" col-sm-6 col-lg-6">
                <div className="imagedrop" onClick={() => fileInputRef1.current.click()}>
                  <input
                    type="file"
                    ref={fileInputRef1}
                    onChange={(event) =>
                      handleFileChange(event, fileInputRef1, setSelectedFile1)
                    }
                    accept="image/*"
                    style={{ display: "none" }}
                  />
                  <label>
                    <CameraRetroIcon />
                  </label>
                </div>
                {fileError1 && (
                  <div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={fileError1} classname='errorred  d-block' /></div>
                )}
              </div>
              <div className="col-sm-6 col-lg-6">
                {selectedFile1 && (
                  <div className="imagedropcopy text-end">
                    <div className="col-lg-12 row p-0 m-0">
                      <div className="col-sm-10 col-lg-10 p-0 m-0">
                        <img
                          src={URL.createObjectURL(selectedFile1)}
                          alt="Uploaded"
                          className="thumbnails-upload-images"
                        />
                      </div>
                      <div
                        className="col-sm-2 col-lg-2 p-0 m-0 d-flex align-items-center justify-content-end"
                      >
                        <button
                          onClick={() => handleDelete(1)}
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <MessageLabel className="mt-3" text={"Content Description"} />
            <p className="mt-0 mb-2" style={{ fontSize: '13px', opacity: 0.7 }}>
              This content is displayed on the frontend page (e.g. empty state message or page intro).
            </p>
            <div className="mt-2">
              <JoditEditor
                className="rs-input"
                value={editUser?.content_description}
                onChange={(e) => {
                  handleChangeContentDescription(e);
                }}
              />
            </div>
          </Wrapper>
        </RightWrapper>
      </FormContainer>
    </>
  );
}

export default Update_Site_met_settings;
